"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClientServiceProxy = exports.createClientAkServiceProxy = exports.serverCallStats = void 0;
const _ = __importStar(require("lodash"));
const axios_1 = __importDefault(require("axios"));
// TODO: toinen vaihtoehto esim: https://github.com/dsherret/server-bridge
let mainCache = {};
exports.serverCallStats = {};
function createClientAkServiceProxy(baseurl) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield createClientServiceProxy(baseurl, "AKService");
    });
}
exports.createClientAkServiceProxy = createClientAkServiceProxy;
function createClientServiceProxy(baseurl, clazz) {
    return __awaiter(this, void 0, void 0, function* () {
        function populateProxyFuncs(obj, isDescribeCall) {
            //console.log("..........populateProxyFuncs, obj: ",obj);
            //if (isDescribeCall) console.log(".....describe populateProxyFuncs, proxydef: ",obj);
            /*
            if (obj && obj.akClassName === "TestObject") { // TODO: POC POC POC
              obj.doSthing = async function(...args) {
                return await axiosProxyCall(obj, "doSthing", args);
              };
            }
             */
            if (_.isObject(obj) || _.isArray(obj))
                _.each(obj, val => populateProxyFuncs(val, isDescribeCall));
            // populate functions - TODO: nyt nää tulee turhaan joka objektin mukana vaikka vois tulla vaan kerran jossani type defissä... myösksään client päässä luodut new obj metodit ei toimi
            if (_.isObject(obj)) { // && !_.isArray(obj)) {
                _.each(obj, (val, key) => {
                    //if (isDescribeCall) console.log(".....describe populateProxyFunc: "+key);
                    if (val === "___PROXY_FUNC___") {
                        //console.log(".....create proxy func: ",val);
                        obj[key] = function (...args) {
                            return __awaiter(this, void 0, void 0, function* () {
                                return yield axiosProxyCall(obj, key, args);
                            });
                        };
                    }
                    else if (_.isString(val) && val.match(/^___FUNC___/)) {
                        val = val.replace(/^___FUNC___/, "").replace(/^.*\(/, "function("); // TODO: vois tehä serverillä ... ja nyt mä tajuan että new Function("return "+funcstr)()
                        //console.log(".....deserialize func: ",val);
                        /*
                        let funclines = val.split("\n");
                        let funcstr = funclines.slice(1, funclines.length-1).join("\n"); // eka ja vika rivi pois eli jää func body
                        obj[key] = new Function(funcstr);
                         */
                        try {
                            obj[key] = new Function("return " + val)();
                        }
                        catch (err) {
                            //console.error("PROXY ERROR - failed to create function! error: "+err+"\...key: ",key,"\n...obj: ",obj);
                            console.error("PROXY ERROR - failed to create function! error: " + err + "\...key: ", key, "\n...val: ", val, "\n...obj: ", obj);
                            //throw err;
                        }
                        /*
                        obj[key] = eval(val); // TODO: POC POC POC
                         */
                    }
                });
                //console.log("..........populateProxyFuncs done: ",obj);
            }
            //console.log(".....prklprkl: ",obj);
            return obj;
        }
        function axiosProxyCall(self, funcName, ...args) {
            return __awaiter(this, void 0, void 0, function* () {
                let isDescribeCall = funcName === "__describe";
                // if client side cached method (@cached decorator on function)
                let cached = funcName === "cachedTestMethod"; // TODO: __cached_methods !!!
                let cachekey = cached ? funcName + JSON.stringify(args) : undefined;
                if (cached && self && !self.__cache)
                    self.__cache = {};
                let cache = self ? self.__cache : mainCache;
                //console.log(" *** CACHED: "+cached+", CACHEKEY: "+cachekey+", FUNC: "+funcName+", CACHE: ",cache);
                if (cachekey) {
                    if (cachekey.length > 1000)
                        throw new Error("too long cachekey! maybe this method shouldnt be cached? key: " + cachekey);
                    const res = cache[cachekey];
                    if (res !== undefined) {
                        console.log(" *** FOUND FROM CACHE! CACHEKEY: " + cachekey + ", FUNC: " + funcName); //+", RES: ",res,", SELF: ",self);
                        return res;
                    }
                }
                let serverFuncName = funcName;
                let params;
                if (self) { // endpoint: /service/proxyCall
                    if (!self.akClassName)
                        throw new Error("cannot proxycall, no self.akClassName! self: " + JSON.stringify(self));
                    let selfClass = self.akClassName;
                    params = {
                        self: self,
                        selfClass: selfClass,
                        funcName: funcName,
                        funcArgs: args[0],
                    };
                    serverFuncName = "proxyCall";
                }
                else { // endpoint: /service/funcName
                    params = {
                        args: args[0],
                    };
                }
                let url = baseurl + "/" + serverFuncName + "/" + funcName;
                console.log("\n ---> CALL url: " + url + ", func: " + funcName + ", args: ", args); //, ", params: ",params,", self: ",self);
                try {
                    let res = yield axios_1.default.post(url, params);
                    //console.log("...axios res: ", res.data);
                    let res2 = populateProxyFuncs(res.data, isDescribeCall);
                    if (res2 === "___UNDEFINED___")
                        res2 = undefined;
                    console.log("\n <--- CALL url: " + url + ", func: " + funcName + ", args: ", args); //, ", result: ",res2);
                    if (isDescribeCall) {
                        //console.log(" <--- CALL describe res.data: ",res.data);
                        //console.log(" <--- CALL describe res2: ",res2);
                    }
                    exports.serverCallStats[funcName || "-"] = (exports.serverCallStats[funcName || "-"] || 0) + 1;
                    if (cachekey) {
                        cache[cachekey] = res2;
                    }
                    return res2;
                }
                catch (err) {
                    console.error("AXIOS ERR: ", (err.response || err));
                    if (err.response) {
                        const errmsg1 = "PROXY ERROR! func: " + funcName + ", status: " + err.response.status + " " + err.response.statusText;
                        const errmsg2 = err.response.data ? err.response.data.errorString : undefined;
                        console.error(new Error(errmsg1 + ", message: " + errmsg2));
                        throw new Error(errmsg2 || errmsg1);
                    }
                    else {
                        throw err;
                    }
                }
            });
        }
        /*
        function createProxyFunc(funcname: string) {
          return async function (...args: any[]) {
            return await axiosProxyCall(undefined, funcname, args);
          }
        }
         */
        function axiosServerDescribeClass(clazz) {
            return __awaiter(this, void 0, void 0, function* () {
                console.log("createClientServiceProxy... clazz: " + clazz + ", describe...");
                //console.log(new Error("createClientServiceProxy TRACE"));
                const proxydef = yield axiosProxyCall({ akClassName: clazz }, "__describe"); // describe kutsu
                console.log("createClientServiceProxy... describe done, proxydef: " + proxydef);
                return proxydef;
                /*
                tuossa nyt sit luodaan uusi service objekti joka kutsulla mut eikai se haittaa
                let proxy = {};
                //Object.getOwnPropertyNames(IAKService.prototype).forEach(key => proxy[key] = createProxyFunc(key)); // TODO: interface propsit jotenki
                //["getAllTestObjects","findAllProjects","getConsoleProject","getConsoleElementMappingContext","mapFormulaToElement",""].forEach(key => proxy[key] = createProxyFunc(key));
                _.keys(proxydef).forEach(key => proxy[key] = createProxyFunc(key)); // jos proxydefiä kutsuttais suoraan niin menis kutsut serverillä aina new AKService():lle jossa tulis esim "AKProject not defined"
                return proxy as IAKService;
                 */
            });
        }
        return yield axiosServerDescribeClass(clazz);
    });
}
exports.createClientServiceProxy = createClientServiceProxy;
